import { render, staticRenderFns } from "./OfferDetail.vue?vue&type=template&id=200a3368&scoped=true"
import script from "./OfferDetail.vue?vue&type=script&lang=js"
export * from "./OfferDetail.vue?vue&type=script&lang=js"
import style0 from "./OfferDetail.vue?vue&type=style&index=0&id=200a3368&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200a3368",
  null
  
)

export default component.exports